import { EditorView } from "@codemirror/view";

export const reviewTrackChangesTheme = EditorView.baseTheme({
    "&light .ol-cm-change-c": {
        backgroundColor: "transparent",
        textDecorationLine: "underline",
        textDecorationColor: "var(--color-HighlightYellow)",
        textDecorationThickness: "3px",
        textUnderlineOffset: "2px",
        textDecorationSkipInk: "none",
    },
    "&light .ol-cm-change-highlight-c, &light .ol-cm-change-focus-c": {
        backgroundColor: "transparent",
        textDecorationLine: "underline",
        textDecorationColor: "var(--color-HighlightYellow)",
        textDecorationThickness: "4px",
        textUnderlineOffset: "2px",
        textDecorationSkipInk: "none",
    },
    "&dark .ol-cm-change-c": {
        backgroundColor: "transparent",
        textDecorationLine: "underline",
        textDecorationColor: "var(--color-HighlightYellow)",
        textDecorationThickness: "3px",
        textUnderlineOffset: "2px",
        textDecorationSkipInk: "none",
    },
    "&dark .ol-cm-change-highlight-c, &dark .ol-cm-change-focus-c": {
        backgroundColor: "transparent",
        textDecorationLine: "underline",
        textDecorationColor: "var(--color-HighlightYellow)",
        textDecorationThickness: "4px",
        textUnderlineOffset: "2px",
        textDecorationSkipInk: "none",
    },
});
